import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import React from 'react';
import { EntityWithIdFields } from 'src/types';
import CardActions from 'src/pages/sistema/components/CardActions';
import { useAFOCLTablaValor } from '../hooks/useTablaValorAFOCL';
import { OperacionAFOCLTablaValorFields } from '../types/fields';
import { OperacionAFOCL } from '../types/types';

interface SeccionAFOCLTablaValoresProps {
  operacion: OperacionAFOCL
}

const SeccionAFOCLTablaValores = ({ operacion }: SeccionAFOCLTablaValoresProps) => {
  const { headers, rows, isLoading, isError, error } = useAFOCLTablaValor(
    operacion[EntityWithIdFields.Id]
  );


  // para aplicar estilo especial al "no aplica"
  const getStyleForValue = (valor: string | undefined) => {
    if (valor === 'No Aplica') {

      return { color: '#999', fontStyle: 'italic' as const, textAlign: 'center' as const };
    }

    return { textAlign: 'center' as const };
  };

  return (
    <CardActions title='Tabla de Valores' icon='mdi:table-check' colapsable tableContent>
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>
        : (
          /* No uso TableList porque complica la tabla con dobleheader */
          <TableContainer component={Paper} sx={{ overflowX: 'auto', boxShadow: 'none', border: '1px solid #e0e0e0' }}>
            <Table stickyHeader aria-label="tabla de valores aforo">
              <TableHead>
                <TableRow>
                  <TableCell
                    rowSpan={2}
                    sx={{ verticalAlign: 'middle', fontWeight: 'bold', minWidth: '150px', borderRight: '1px solid #e0e0e0' }}
                  >
                    Instrumento
                  </TableCell>
                  {headers.map((header) => (
                    <TableCell
                      key={`top-${header.codOperacionTipo}`}
                      colSpan={2}
                      align="center"
                      sx={{ fontWeight: 'bold', borderBottom: '1px solid #e0e0e0' }}
                    >
                      {header.descOperacionTipo}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  {headers.map((header) => (
                    <React.Fragment key={`sub-${header.codOperacionTipo}`}>
                      <TableCell align="center" sx={{ borderTop: '1px solid #ccc', fontSize: '0.85rem' }}>
                        Puente
                      </TableCell>
                      <TableCell align="center" sx={{ borderTop: '1px solid #ccc', fontSize: '0.85rem' }}>
                        Cliente
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIndex) => (
                  <TableRow key={`row-${rowIndex}`} hover>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '0.85rem', borderRight: '1px solid #e0e0e0' }}>
                      {row.descInstrumento}
                    </TableCell>
                    {headers.map((header) => {
                      const celda = row.celdas[header.codOperacionTipo];
                      const valorPuente = celda ? celda[OperacionAFOCLTablaValorFields.ValorPuente] : '-';
                      const valorCliente = celda ? celda[OperacionAFOCLTablaValorFields.ValorCliente] : '-';
                      return (
                        <React.Fragment key={`cell-${rowIndex}-${header.codOperacionTipo}`}>
                          <TableCell sx={{ ...getStyleForValue(valorPuente), fontSize: '0.85rem' }}>
                            {valorPuente}
                          </TableCell>
                          <TableCell sx={{ ...getStyleForValue(valorPuente), fontSize: '0.85rem' }}>
                            {valorCliente}
                          </TableCell>
                        </React.Fragment>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
    </CardActions>
  );
};

export default SeccionAFOCLTablaValores;
